import { Transfer } from 'antd';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { setTargetKeys } from '../../../redux/peakList/action';
import CustomModal from "../../../hoc/CustomModal";
import PopComponent from "../../popContent";
import { addRecommendedLeader } from '../../../api/thoughtLeaders';

const PeakList = ({ thoughtLeader, handleOpenModal }) => {
    const [modalName, setModalName] = useState("UserPop");
    const [openModal, setModalOpen] = useState(false);
    const [error, setError] = useState({});
    let Modal = PopComponent[modalName];
    const thoughtLeaderData = [];

    thoughtLeader.map(data => {
        if (data.mail_activate) {
            thoughtLeaderData.push({
                key: data._id,
                title: data.userdetails?.first_name + ' ' + data.userdetails?.last_name,
                description: data.name || data.title,
            })
        }
    });

    const targetKeys = useSelector(state => state.peakListReducer)
    const dispatch = useDispatch();

    const [selectedKeys, setSelectedKeys] = useState([]);

    const onChange = (nextTargetKeys, direction, moveKeys) => {
        if (direction === 'right') {
            dispatch(setTargetKeys(nextTargetKeys))
        } else if (direction === 'left') {
            dispatch(setTargetKeys(nextTargetKeys))
        }
    };

    const onSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
        setSelectedKeys([...targetSelectedKeys, ...sourceSelectedKeys]);
    };

    const handleSubmit = () => {
        const rec = addRecommendedLeader
        const req = {}
        req.tl_ids = [...targetKeys]
        rec(req).then(res => {
            if (res.data.status === 200) {
                handlePopModal('ErrorPop', { header: "Success", body: res.data.message })
            } else {
                handlePopModal('ErrorPop', { header: "Error", body: res.data.message })
            }
        }).catch(err => {
            handlePopModal('ErrorPop', { header: "Error", body: err.message })
        })
    };

    const handlePopModal = (type, data) => {
        let flag = 0;
        switch (type) {
            case 'ErrorPop': {
                setModalName(type);
                setError(data)
                setModalOpen(!openModal);
                break;
            }
            default: {
                setModalName(type);
                setModalOpen(!openModal);
                break;
            }
        }
        if (flag === 1) {
            setModalName(type);
            setModalOpen(!openModal);
        }
    };

    return (
        <div className="peak_list">
            <h2 className='mb_0'>Thought Leader List</h2>
            <span className='Peak_list_subtitle'>carousel</span>
            <Transfer
                dataSource={thoughtLeaderData}
                titles={['Source', 'Target']}
                targetKeys={targetKeys}
                selectedKeys={selectedKeys}
                onChange={onChange}
                onSelectChange={onSelectChange}
                render={item => item.title}
                showSelectAll={false}
                showSearch={true}
                oneWay={true}
            />
            <div class="form_group form_footer">
                <button onClick={() => handleOpenModal()} type="reset" class="btn btn_gray">Cancel</button>
                <button onClick={() => handleSubmit()} type="submit" class="btn btn_primary">submit</button>
            </div>
            {Modal && (
                <CustomModal className={`${modalName === 'ErrorPop' ? 'ant-modal modal skill_model' : 'modal peak_model'} ${modalName === 'ErrorPop' ? 'errorPop' : ''}`} handleOpen={handleOpenModal} open={openModal}>
                    <Modal
                        error={error}
                        handleOpenModal={handleOpenModal}
                    />
                </CustomModal>
            )
            }
        </div>
    )
};

export default PeakList